import React, { useState } from "react";
import { useGetFileStructureQuery } from "../../../../features/fileManager/fileManagerApiSlice";
import FolderTreeView from "./FolderTreeView";
import PreviewFileFolderView from "./PreviewFileFolderView"; // New Component for Preview
import { Box, Grid } from "@mui/material";

function FolderView() {
  const { data: fileStructure } = useGetFileStructureQuery();
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileSelect = (file) => {
    setSelectedFile(file); // Set the selected file when a file is clicked
  };

  return (
    <Box mt={2}>
      <Grid container spacing={2}>
        <Grid
          item
          sx={{
            overflow: "auto",
            maxHeight: "80vh",
          }}
          xs={4}
        >
          {fileStructure && (
            <FolderTreeView
              data={fileStructure}
              onFileSelect={handleFileSelect}
            />
          )}
        </Grid>
        <Grid item xs={8}>
          {selectedFile && <PreviewFileFolderView file={selectedFile} />}
        </Grid>
      </Grid>
    </Box>
  );
}

export default FolderView;
